export default __webpack_public_path__ + "static/media/article06.d7b71fb1.md";